import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import { FranjaDeAmbiente, MarcaDeAguaDeImpresion } from './entorno/MarcaAmbiente';
import { marcarPestaniaDeEntorno } from './entorno/entorno';

marcarPestaniaDeEntorno();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <FranjaDeAmbiente />
      <MarcaDeAguaDeImpresion />
      <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

//serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
reportWebVitals();